/* CZ rich PDP — the 3-tier buy box (snippets/kv-sgi-ladder.liquid explains the rules).
   What a tier puts in the cart:
     tier 1  this deck
     tier 2  this deck + the pressed pick; the Mluvme Spolu + Kids pair goes in as
             the Rodinný balíček SKU at its own price
     tier 3  all three decks; the pair inside them goes in as the Rodinný balíček
   Prices are the cards' own data-price (Liquid, contextual CZK); nothing is typed here. */
(function () {
  var root = document.querySelector('[data-kvsgi-ladder]');
  if (!root) return;

  // ── cz-ladder-v1: this box vs the theme's own buy box (snippet header) ──
  // Bookkeeping copied from the HU buybox-ladder-v1 (korvonal-buybox-ladder.js)
  // with its own storage keys and cart attribute, so the two never share an arm.
  var EXPERIMENT = 'cz-ladder-v1';
  var ATTR = '_experiment_cz_ladder';
  var ARM_KEY = 'kv_czl_arm', FIRED_KEY = 'kv_czl_exposed', VIEW_KEY = 'kv_czl_pdpv';
  var VISITOR_KEY = 'otto_visitor_id';
  var ENDPOINT = 'https://api.korvonal.com/api/storefront-events/cmpismusd0000b965jxyb4r46';
  var MODE = root.getAttribute('data-mode') || 'on';
  var forcedM = /[?&]ladder=([ab])(?:[&#]|$)/.exec(location.search);
  var FORCED = forcedM ? (forcedM[1] === 'b' ? 'ladder' : 'control') : null;

  // Sticky per browser. Storage blocked in `ab`: no arm, so they keep today's
  // box and are neither stamped nor exposed (stamping them would add
  // unrandomised orders to one arm only).
  var ARM = (function () {
    if (FORCED || MODE !== 'ab') return null;
    try {
      var s = localStorage.getItem(ARM_KEY);
      if (s === 'control' || s === 'ladder') return s;
      s = Math.random() < 0.5 ? 'control' : 'ladder';
      localStorage.setItem(ARM_KEY, s);
      return s;
    } catch (e) { return null; }
  })();
  var SHOWN = FORCED || ARM || (MODE === 'off' ? 'control' : 'ladder');

  function visitorId() {
    try {
      var v = localStorage.getItem(VISITOR_KEY);
      if (!v) {
        v = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : 'v-' + Date.now() + '-' + Math.random().toString(16).slice(2);
        localStorage.setItem(VISITOR_KEY, v);
      }
      return v;
    } catch (e) { return null; }
  }
  function post(events) {
    try {
      fetch(ENDPOINT, { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ events: events }) }).catch(function () {});
    } catch (e) { /* bookkeeping never blocks the customer */ }
  }
  function pdpEvent(vid, name, id) {
    return { id: id, eventName: name, clientId: vid, occurredAt: new Date().toISOString(), url: location.href,
      data: { experimentKey: EXPERIMENT, variant: ARM, handle: root.getAttribute('data-hero-handle') } };
  }
  function isCartAdd(input) {
    try {
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      return /\/cart\/add(\.js)?([?#]|$)/.test(new URL(u, location.href).pathname);
    } catch (e) { return false; }
  }
  // Both arms are stamped and exposed on PDP view. czl_pdp_view once per
  // visitor, czl_pdp_atc on every successful /cart/add from this page,
  // whichever button made it (theme form, sticky bar, this box), seen by
  // wrapping fetch; the readout counts distinct adders.
  if (ARM) {
    var attrs = {}; attrs[ATTR] = EXPERIMENT + ':' + ARM;
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs }) }).catch(function () {});
    var vid = visitorId();
    if (vid) {
      var seenView = null, seenExp = null;
      try { seenView = localStorage.getItem(VIEW_KEY); if (!seenView) localStorage.setItem(VIEW_KEY, '1'); } catch (e) {}
      if (!seenView) post([pdpEvent(vid, 'czl_pdp_view', 'czl_pdp_view:' + EXPERIMENT + ':' + vid)]);
      try { seenExp = localStorage.getItem(FIRED_KEY); if (!seenExp) localStorage.setItem(FIRED_KEY, '1'); } catch (e) {}
      if (!seenExp) post([{ id: EXPERIMENT + ':' + vid, eventName: 'experiment_exposure', clientId: vid, occurredAt: new Date().toISOString(), url: location.href, data: { experimentKey: EXPERIMENT, variant: ARM } }]);
      if (!window.__kvCzlAtcHooked && typeof window.fetch === 'function') {
        window.__kvCzlAtcHooked = true;
        var seq = 0, nativeFetch = window.fetch;
        window.fetch = function (input) {
          var p = nativeFetch.apply(window, arguments);
          try {
            if (isCartAdd(input)) p.then(function (r) { if (r && r.ok) post([pdpEvent(vid, 'czl_pdp_atc', 'czl_pdp_atc:' + vid + ':' + Date.now() + ':' + (seq++))]); }, function () {});
          } catch (e) {}
          return p;
        };
      }
    }
  }
  // Control: the theme's own price, add-to-cart and sticky bar stay as they are.
  if (SHOWN === 'control') { root.parentNode && root.parentNode.removeChild(root); return; }

  var HERO = { variant: +root.getAttribute('data-hero-variant'), price: +root.getAttribute('data-hero-price'), handle: root.getAttribute('data-hero-handle') };
  var PAIR = (root.getAttribute('data-pair') || '').split('|');
  var BUNDLE = root.getAttribute('data-bundle-variant')
    ? { variant: +root.getAttribute('data-bundle-variant'), price: +root.getAttribute('data-bundle-price'), title: root.getAttribute('data-bundle-title') }
    : null;
  var THRESHOLD = +root.getAttribute('data-threshold') || 0;
  var T_WAS = root.getAttribute('data-t-was'), T_BUNDLE = root.getAttribute('data-t-bundle'), T_STICKY = root.getAttribute('data-t-sticky');
  var tiers = [].slice.call(root.querySelectorAll('[data-kv-tier]'));
  var cta = root.querySelector('[data-kv-cta]'), ctaText = root.querySelector('[data-kv-cta-text]'), msg = root.querySelector('[data-kv-msg]');
  var current = null;

  // Money as the store prints it in Czech: "1 337 Kč" (no-break space groups); SK pays in EUR: "€36,95".
  var CUR = root.getAttribute('data-cur') || 'CZK';
  function money(cents) {
    if (CUR === 'EUR') return '€' + (cents / 100).toFixed(2).replace('.', ',');
    return String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' Kč';
  }

  // The games a tier holds, hero first: [{variant, price, handle}]
  function games(tier) {
    var out = [HERO];
    [].forEach.call(tier.querySelectorAll('[data-kv-pick][aria-pressed="true"], [data-kv-fixed]'), function (el) {
      out.push({ variant: +el.getAttribute('data-variant'), price: +el.getAttribute('data-price'), handle: el.getAttribute('data-handle') });
    });
    return out;
  }

  // What goes in the cart for those games, and what it costs.
  function basket(tier) {
    var g = games(tier);
    var sum = g.reduce(function (s, x) { return s + x.price; }, 0);
    var pair = g.filter(function (x) { return PAIR.indexOf(x.handle) !== -1; });
    if (BUNDLE && pair.length === 2) {
      var rest = g.filter(function (x) { return PAIR.indexOf(x.handle) === -1; });
      return {
        items: [{ id: BUNDLE.variant, quantity: 1 }].concat(rest.map(function (x) { return { id: x.variant, quantity: 1 }; })),
        total: BUNDLE.price + rest.reduce(function (s, x) { return s + x.price; }, 0),
        sum: sum, bundle: true, count: g.length
      };
    }
    return { items: g.map(function (x) { return { id: x.variant, quantity: 1 }; }), total: sum, sum: sum, bundle: false, count: g.length };
  }

  function render(tier) {
    var b = basket(tier);
    var price = tier.querySelector('[data-kv-tier-price]');
    price.textContent = money(b.total);
    if (b.sum > b.total) {
      var was = document.createElement('span');
      was.className = 'kv-tier__was';
      was.textContent = T_WAS.replace('[price]', money(b.sum));
      price.appendChild(was);
    }
    var desc = tier.querySelector('[data-kv-desc]');
    // Tier 2 says when its pair becomes the family bundle; tier 3 always reads "all three".
    if (desc) desc.textContent = b.bundle && tier.getAttribute('data-max') === '1' ? T_BUNDLE.replace('[bundle]', BUNDLE.title) : desc.getAttribute('data-default');
    var badge = tier.querySelector('[data-kv-freeship]');
    if (badge) badge.hidden = !(THRESHOLD && b.total / 100 >= THRESHOLD);
    if (tier === current) {
      ctaText.textContent = cta.getAttribute('data-label').replace('[price]', money(b.total));
      stickySync(b);
    }
    return b;
  }

  function select(tier) {
    current = tier;
    tiers.forEach(function (t) {
      var on = t === tier;
      t.classList.toggle('is-selected', on);
      t.setAttribute('aria-checked', on ? 'true' : 'false');
      var slots = t.querySelector('[data-kv-slots]');
      if (slots) slots.hidden = !on;
    });
    render(tier);
  }

  tiers.forEach(function (tier) {
    var picks = [].slice.call(tier.querySelectorAll('[data-kv-pick]'));
    if (picks[0]) picks[0].setAttribute('aria-pressed', 'true'); // the lift-ranked companion comes first
    picks.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        picks.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        if (tier !== current) select(tier); else render(tier);
      });
    });
    tier.addEventListener('click', function () { if (tier !== current) select(tier); });
    tier.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); select(tier); }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        var next = tiers[tiers.indexOf(tier) + (e.key === 'ArrowDown' ? 1 : -1)];
        if (next) { next.focus(); select(next); }
      }
    });
    render(tier);
  });

  // The theme's price block, add-to-cart button and the "bought together" box
  // below it would offer the same games a second time (the HU ladder hides the
  // same three; its CSS is keyed on html.kv-ladder-on).
  document.documentElement.classList.add('kv-ladder-on');
  var next = root.parentNode;
  while (next && (next = next.nextElementSibling)) {
    if (next.classList && next.classList.contains('product-recommendation')) { next.hidden = true; break; }
  }
  [].forEach.call(document.querySelectorAll('.product-recommendation'), function (box) {
    if (box.querySelector('a[href*="/products/mluvme-spolu-family-bundle"], a[href*="/products/rodinny-balicek"]')) box.hidden = true;
  });

  // The theme's sticky bar: its price follows the chosen tier, its button runs
  // this add, and it waits until this button has scrolled out above.
  function stickyBar() { return document.querySelector('sticky-add-to-cart'); }
  function stickySync(b) {
    var bar = stickyBar(); if (!bar) return;
    var el = bar.querySelector('.sticky-add-to-cart__price-original') || bar.querySelector('[data-js-atc-price]');
    if (el) el.textContent = b.count > 1 ? T_STICKY.replace('[n]', b.count).replace('[price]', money(b.total)) : money(b.total);
  }
  (function stickyHook() {
    var bar = stickyBar(); if (!bar) return;
    var btn = bar.querySelector('button[data-js-atc]');
    if (btn) {
      var mine = btn.cloneNode(true);
      btn.parentNode.replaceChild(mine, btn);
      mine.addEventListener('click', function (e) { e.preventDefault(); cta.click(); });
    }
    function gate() {
      var r = cta.getBoundingClientRect();
      if ((r.width === 0 && r.height === 0) || r.bottom > 0) bar.setAttribute('data-kv-below', ''); else bar.removeAttribute('data-kv-below');
    }
    window.addEventListener('scroll', gate, { passive: true });
    window.addEventListener('resize', gate);
    setTimeout(gate, 0);
  })();

  function openDrawer() {
    return fetch('?section_id=helper-cart').then(function (r) { return r.text(); }).then(function (text) {
      if (typeof window.renderHelperCart === 'function') window.renderHelperCart(text);
      var drawer = document.getElementById('site-cart-sidebar');
      if (drawer && typeof drawer.show === 'function') drawer.show(); else window.location.href = '/cart';
    });
  }
  cta.addEventListener('click', function () {
    if (!current || cta.classList.contains('is-busy')) return;
    var b = basket(current);
    cta.classList.add('is-busy'); cta.setAttribute('aria-busy', 'true'); msg.hidden = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: b.items }) })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return openDrawer(); })
      .catch(function () { msg.textContent = root.getAttribute('data-t-err'); msg.hidden = false; })
      .then(function () { cta.classList.remove('is-busy'); cta.removeAttribute('aria-busy'); });
  });

  select(tiers[0]);
  root.hidden = false;
})();
